; (function () {
  const testimonials = () => {
    $('.testimonials').each(function () {
      const $section = $(this);

      const mainSwiperEl = $section.find(".testimonials-swiper")[0];
      const thumbnailEl = $section.find(".thumb-swiper")[0];

      const prev = $section.find(".prev")[0];
      const next = $section.find(".next")[0];

      // 初始化缩略图 Swiper
      const thumbnailSwiper = new Swiper(thumbnailEl, {
        slidesPerView: 4,
        spaceBetween: 10,
        watchSlidesVisibility: true,
        breakpoints: {
          768: {
            slidesPerView: 5,
            spaceBetween: 20,
          },
          1200: {
            slidesPerView: 6,
          }
        }
      });

      // 初始化主 Swiper
      new Swiper(mainSwiperEl, {
        slidesPerView: 1,
        spaceBetween: 10,
        autoHeight: true,
        thumbs: {
          swiper: thumbnailSwiper,
        },
        navigation: {
          prevEl: prev,
          nextEl: next,
        },
      });
    });
  };

  document.addEventListener('DOMContentLoaded', function () {
    testimonials();

    document.addEventListener('shopify:section:load', function () {
      testimonials();
    });
  });
})();
